const mutations = {
  SET_QUEUES(state, payload) {
    state.queues = payload || []
    state.error = null
  },
  SET_ACCOUNTS(state, payload) {
    state.accounts = payload || []
    state.error = null
  },
  SET_LOADING(state, val) {
    state.loading = !!val
  },
  SET_ERROR(state, err) {
    state.error = err || null
  },
  
  // Meaning Analysis Duration widgets

  // Meaning Analysis Duration mutations
  SET_MEANING_ANALYSIS_LOADING(state, { widgetId, loading }) {
    if (!state.meaningAnalysisWidgets) {
      state.meaningAnalysisWidgets = {}
    }
    if (!state.meaningAnalysisWidgets[widgetId]) {
      state.meaningAnalysisWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.meaningAnalysisWidgets[widgetId].loading = !!loading
  },
  SET_MEANING_ANALYSIS_ERROR(state, { widgetId, error }) {
    if (!state.meaningAnalysisWidgets) {
      state.meaningAnalysisWidgets = {}
    }
    if (!state.meaningAnalysisWidgets[widgetId]) {
      state.meaningAnalysisWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.meaningAnalysisWidgets[widgetId].error = error || null
  },
  SET_MEANING_ANALYSIS_DATA(state, { widgetId, data }) {
    if (!state.meaningAnalysisWidgets) {
      state.meaningAnalysisWidgets = {}
    }
    if (!state.meaningAnalysisWidgets[widgetId]) {
      state.meaningAnalysisWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.meaningAnalysisWidgets[widgetId].data = data || null
  },

  // Generic operational widgets mutations
  SET_OPERATIONAL_WIDGET_LOADING(state, { widgetId, loading }) {
    if (!state.operationalWidgets) {
      state.operationalWidgets = {}
    }
    if (!state.operationalWidgets[widgetId]) {
      state.operationalWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.operationalWidgets[widgetId].loading = !!loading
  },
  SET_OPERATIONAL_WIDGET_ERROR(state, { widgetId, error }) {
    if (!state.operationalWidgets) {
      state.operationalWidgets = {}
    }
    if (!state.operationalWidgets[widgetId]) {
      state.operationalWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.operationalWidgets[widgetId].error = error || null
  },
  SET_OPERATIONAL_WIDGET_DATA(state, { widgetId, data }) {
    if (!state.operationalWidgets) {
      state.operationalWidgets = {}
    }
    if (!state.operationalWidgets[widgetId]) {
      state.operationalWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.operationalWidgets[widgetId].data = data || null
  },

  // Time widgets mutations
  SET_TIME_LOADING(state, { widgetId, loading }) {
    if (!state.timeWidgets) {
      state.timeWidgets = {}
    }
    if (!state.timeWidgets[widgetId]) {
      state.timeWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.timeWidgets[widgetId].loading = !!loading
  },
  SET_TIME_ERROR(state, { widgetId, error }) {
    if (!state.timeWidgets) {
      state.timeWidgets = {}
    }
    if (!state.timeWidgets[widgetId]) {
      state.timeWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.timeWidgets[widgetId].error = error || null
  },
  SET_TIME_DATA(state, { widgetId, data }) {
    if (!state.timeWidgets) {
      state.timeWidgets = {}
    }
    if (!state.timeWidgets[widgetId]) {
      state.timeWidgets[widgetId] = { loading: false, error: null, data: null }
    }
    state.timeWidgets[widgetId].data = data || null
  }
}
export default mutations
